import PurchaseDocsPage from "./PurchaseDocsPage";

// فواتير المورّدين: نفس أسلوب قوائم المستندات (بحث · مرشّحات · جدول · إجراءات).
export default function PurchaseBillsPage() {
  return <PurchaseDocsPage docType="bill" />;
}
